import React from 'react'
import './style.scss'
import { FaPhoneAlt, FaArrowRight } from 'react-icons/fa'
import { useLanguage } from '../../i18n'

const CallToAction = () => {
    const { t } = useLanguage();

    return (
        <section className="ctaArea">
            <div className="container">
                <div className="ctaWrapper">
                    <div className="ctaContent">
                        <h2>{t('cta.title')}</h2>
                        <p>{t('cta.description')}</p>
                    </div>
                    <div className="ctaButtons">
                        <a href="tel:+919555690946" className="btnPhone">
                            <FaPhoneAlt />
                            <span>{t('cta.callNow')}</span>
                        </a>
                        <a href="https://wa.me/+919555690946?text=Hello%2C%20I%20would%20like%20to%20schedule%20a%20consultation." target="_blank" rel="noopener noreferrer" className="btnConsult">
                            <span>{t('cta.freeConsultation')}</span>
                            <FaArrowRight />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CallToAction
